import { useReactiveVar } from '@apollo/client';
import { currentDeepLinkPriceTypeVar } from './currentDeepLinkPriceType';
export function useCurrentDeepLinkPriceType() {
    return useReactiveVar(currentDeepLinkPriceTypeVar);
}
